export default "__VITE_ASSET__83PeHGft__"